import C from "./Constants.js";
export function isTagInGatewayRange(tag) {
  return tag?.data?.businessState === C.TAG_BUSINESS_STATES.AVAILABLE || tag?.data?.businessState === C.TAG_BUSINESS_STATES.PAIRED;
}
export function canSendTagRingCommand(tag) {
  return isTagInGatewayRange(tag) && (tag?.data?.commands?.ring?.state == null || tag?.data?.commands?.ring?.state === C.TAG_RING_COMMAND_STATES.FAILED || tag?.data?.commands?.ring?.state === C.TAG_RING_COMMAND_STATES.CANCELLED || tag?.data?.commands?.ring?.state === C.TAG_RING_COMMAND_STATES.DELIVERED && Date.now() - C.RINGING_DURATION_MS - C.RINGING_COMMAND_COOLDOWN_MS > tag.data?.commands?.ring?.deliveredAt);
}
export function canCancelTagRingCommand(tag) {
  return isTagInGatewayRange(tag) && tag.data?.commands?.ring?.state === C.TAG_RING_COMMAND_STATES.WAITING_FOR_DETECTION;
}
export function isTagRinging(tag) {
  return tag?.data?.commands?.ring?.state === C.TAG_RING_COMMAND_STATES.DELIVERED && Date.now() - C.RINGING_DURATION_MS - C.RINGING_COMMAND_COOLDOWN_MS < tag.data?.commands?.ring?.deliveredAt;
}
export function isTagWaitingForDetection(tag) {
  return tag?.data?.commands?.ring?.state === C.TAG_RING_COMMAND_STATES.WAITING_FOR_DETECTION;
}
export function isTagRingCommandSent(tag) {
  return tag?.data?.commands?.ring?.state === C.TAG_RING_COMMAND_STATES.SENT_TO_GATEWAY_DEVICE;
}